import { useEffect } from "react";

const SITE = "Kootenay Home Pros";
const DEFAULT_DESC = "The Kootenay region directory connecting homeowners with trusted local contractors — plumbing, roofing, renovation, photography and more.";

/**
 * Lightweight per-route SEO: sets document.title and meta description.
 * No react-helmet dependency — works fine for client-rendered pages.
 */
export function useSEO({ title, description } = {}) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE}` : `${SITE} — Columbia Valley Contractors`;
    const desc = description || DEFAULT_DESC;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc);

    // Open Graph title / description
    let ogt = document.querySelector('meta[property="og:title"]');
    if (ogt) ogt.setAttribute("content", title ? `${title} | ${SITE}` : `${SITE} — Columbia Valley Contractors`);
    let ogd = document.querySelector('meta[property="og:description"]');
    if (ogd) ogd.setAttribute("content", desc);
  }, [title, description]);
}
